// extracted by mini-css-extract-plugin
export default {"loader":"withSuspense_loader__1lXKD"};